import { render, staticRenderFns } from "./TestWithSecurityMethod.vue?vue&type=template&id=5ef92d7d"
import script from "./TestWithSecurityMethod.vue?vue&type=script&lang=js"
export * from "./TestWithSecurityMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports